import { render } from "./ThemeLogin.vue?vue&type=template&id=04a1e6a0"
const script = {}

import exportComponent from "C:\\xampp8\\htdocs\\rnd_2026_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__